/* DRIVE IQ — ADVENTURE MODE V600.2 MAIN AUTHORITY
   File: adventure-main.js

   Fixes:
   - Exposes status() safely even while later modules are still loading.
   - Retries boot until all V600 modules are available.
   - Never crashes because Controls or Provider is temporarily undefined.
   - Boots each controller exactly once.
*/

(function(window,document){
"use strict";

if(window.DriveIQAdventureMain){return;}

var booted=false;
var booting=false;
var bootError="";
var bootAttempts=0;
var retryTimer=null;
var MAX_ATTEMPTS=100;
var boundScanComplete=false;

function requiredModules(){
  return [
    "DriveIQAdventureConfig",
    "DriveIQAdventureUtils",
    "DriveIQAdventureState",
    "DriveIQAdventureEvents",
    "DriveIQAdventureMap",
    "DriveIQAdventurePins",
    "DriveIQAdventurePlaceCard",
    "DriveIQAdventureRoute",
    "DriveIQAdventureDestination",
    "DriveIQAdventureSearch",
    "DriveIQAdventureScan",
    "DriveIQAdventureProvider",
    "DriveIQAdventurePhoto",
    "DriveIQAdventureUI",
    "DriveIQAdventureResume",
    "DriveIQAdventureControls"
  ];
}

function missingModules(){
  var missing=[];
  requiredModules().forEach(function(name){
    if(!window[name]){missing.push(name);}
  });
  return missing;
}

function safeStatus(name){
  var controller=window[name];
  if(!controller){return {loaded:false};}

  if(typeof controller.status==="function"){
    try{return controller.status();}
    catch(error){
      return {
        loaded:true,
        statusError:String(
          error&&error.message?error.message:error||"Status failed"
        )
      };
    }
  }

  return {loaded:true};
}

function scheduleRetry(){
  if(booted||retryTimer||bootAttempts>=MAX_ATTEMPTS){return;}

  retryTimer=window.setTimeout(function(){
    retryTimer=null;
    boot();
  },100);
}

function initController(name){
  var controller=window[name];

  if(
    controller &&
    typeof controller.init==="function"
  ){
    return controller.init();
  }

  return true;
}

function bindHighLevelEvents(){
  var events=window.DriveIQAdventureEvents;

  if(!events||boundScanComplete){return;}

  boundScanComplete=true;

  events.on("scan:completed",function(event){
    var payload=event&&event.payload?event.payload:{};
    var state=window.DriveIQAdventureState;
    var map=window.DriveIQAdventureMap;
    var results=payload.results||
      (state&&typeof state.get==="function"
        ? state.get("results.items",[])
        : []);

    if(
      map &&
      typeof map.fitResults==="function" &&
      results &&
      results.length
    ){
      map.fitResults(results,{force:true});
    }
  });
}

function boot(){
  var missing;
  var state;
  var events;
  var config;

  if(booted){return true;}
  if(booting){return false;}

  bootAttempts+=1;
  missing=missingModules();

  if(missing.length){
    bootError="Waiting for: "+missing.join(", ");
    scheduleRetry();
    return false;
  }

  booting=true;
  bootError="";

  try{
    state=window.DriveIQAdventureState;
    events=window.DriveIQAdventureEvents;
    config=window.DriveIQAdventureConfig;

    if(state&&typeof state.initialize==="function"){
      state.initialize();
    }

    initController("DriveIQAdventureUI");

    if(
      window.DriveIQAdventureMap &&
      typeof window.DriveIQAdventureMap.init==="function"
    ){
      if(!window.DriveIQAdventureMap.init()){
        throw new Error("Map controller did not initialize.");
      }
    }

    initController("DriveIQAdventurePlaceCard");
    initController("DriveIQAdventureRoute");
    initController("DriveIQAdventureResume");

    if(
      window.DriveIQAdventureProvider &&
      typeof window.DriveIQAdventureProvider.register==="function"
    ){
      window.DriveIQAdventureProvider.register();
    }

    initController("DriveIQAdventureControls");

    bindHighLevelEvents();

    booted=true;
    booting=false;
    window.DRIVE_IQ_ADVENTURE_MODE_BUILD=
      "V600_2_RESILIENT_MAIN";

    if(events&&typeof events.emit==="function"){
      events.emit("app:ready",{
        build:window.DRIVE_IQ_ADVENTURE_MODE_BUILD,
        bootAttempts:bootAttempts
      });
    }

    if(
      config &&
      config.logging &&
      config.logging.enabled &&
      window.console &&
      window.console.log
    ){
      console.log(
        config.logging.prefix,
        "V600 modular app ready",
        window.DRIVE_IQ_ADVENTURE_MODE_BUILD
      );
    }

    return true;
  }catch(error){
    booting=false;
    bootError=String(
      error&&error.message
        ? error.message
        : error||"Boot failed"
    );

    if(window.console&&window.console.error){
      console.error(
        "[Drive IQ Adventure V600] Main boot failed",
        error
      );
    }

    scheduleRetry();
    return false;
  }
}

function status(){
  return {
    build:
      window.DRIVE_IQ_ADVENTURE_MODE_BUILD||
      "V600_2_RESILIENT_MAIN",
    booted:booted,
    booting:booting,
    bootAttempts:bootAttempts,
    bootError:bootError,
    missing:missingModules(),
    provider:safeStatus("DriveIQAdventureProvider"),
    controls:safeStatus("DriveIQAdventureControls"),
    map:safeStatus("DriveIQAdventureMap"),
    scan:safeStatus("DriveIQAdventureScan")
  };
}

function destroy(){
  if(retryTimer){
    window.clearTimeout(retryTimer);
    retryTimer=null;
  }

  [
    "DriveIQAdventureControls",
    "DriveIQAdventureResume",
    "DriveIQAdventureRoute",
    "DriveIQAdventurePlaceCard",
    "DriveIQAdventureUI",
    "DriveIQAdventureMap"
  ].forEach(function(name){
    var controller=window[name];
    if(controller&&typeof controller.destroy==="function"){
      try{controller.destroy();}catch(error){}
    }
  });

  booted=false;
  booting=false;
  boundScanComplete=false;
  return true;
}

window.DriveIQAdventureMain={
  boot:boot,
  status:status,
  destroy:destroy
};

if(document.readyState==="loading"){
  document.addEventListener(
    "DOMContentLoaded",
    boot,
    {once:true}
  );
}else{
  boot();
}

window.addEventListener(
  "load",
  boot,
  {once:true}
);

scheduleRetry();

})(window,document);
